import { render, staticRenderFns } from "./TextAndCounter.vue?vue&type=template&id=d7205330&scoped=true&"
import script from "./TextAndCounter.vue?vue&type=script&lang=js&"
export * from "./TextAndCounter.vue?vue&type=script&lang=js&"
import style0 from "./TextAndCounter.vue?vue&type=style&index=0&id=d7205330&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7205330",
  null
  
)

export default component.exports